import React, { Component } from 'react';
import { View, Text } from 'react-native';
import Moment from 'moment';
import * as timezone from 'moment-timezone';
import 'moment/locale/pt-br';
import Colors from '../../config/Colors';

class HistoricoStatus extends Component {
    toDayOfTheWeekAndDate = (dhInclusao) => {
        return `${Moment(dhInclusao).format('dddd')}, ${Moment(
            dhInclusao
        ).format('DD')} de ${Moment(dhInclusao).format('MMMM')}`;
    };

    toHours = (value) => {
        const { dsTimeZone } = this.props,
            date = timezone.tz(value, dsTimeZone);

        return Moment(date, 'YYYY-MM-DD HH:mm:ss').format('HH[h]mm');
    };

    render() {
        return (
            <View>
                {this.props.listStatus.map((item, index) => (
                    <View
                        style={{
                            marginTop: index > 0 ? -25 : 0
                        }}
                        key={index}
                    >
                        <View style={{ marginLeft: 16, marginBottom: 8 }}>
                            <Text
                                style={{
                                    fontFamily: 'NunitoSans-Regular',
                                    fontSize: 12,
                                    color: '#626262'
                                }}
                            >
                                {this.toDayOfTheWeekAndDate(item.dhInclusao)}
                            </Text>
                        </View>

                        <View
                            style={{
                                flexDirection: 'row',
                                alignItems: 'center'
                            }}
                        >
                            {index === 0 ? (
                                <View
                                    style={{
                                        borderWidth: 1,
                                        borderRadius: 50,
                                        borderColor: Colors.secondary,
                                        height: 15,
                                        width: 15,
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        marginRight: 16,
                                        marginBottom: 4
                                    }}
                                />
                            ) : index + 1 !== this.props.listStatus.length ? (
                                <View
                                    style={{
                                        borderRadius: 50,
                                        borderColor: Colors.secondary,
                                        height: 7,
                                        width: 7,
                                        backgroundColor: Colors.secondary,
                                        marginLeft: 3,
                                        marginRight: 16
                                    }}
                                />
                            ) : (
                                <View
                                    style={{
                                        borderWidth: 1,
                                        borderRadius: 50,
                                        borderColor: Colors.secondary,
                                        height: 15,
                                        width: 15,
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        marginRight: 16,
                                        marginTop: 4
                                    }}
                                >
                                    <View
                                        style={{
                                            borderRadius: 50,
                                            borderColor: Colors.secondary,
                                            height: 7,
                                            width: 7,
                                            backgroundColor: Colors.secondary
                                        }}
                                    />
                                </View>
                            )}

                            <View>
                                <View style={{ flexDirection: 'row' }}>
                                    <Text
                                        style={{
                                            fontFamily: 'NunitoSans-Regular',
                                            fontSize: 14,
                                            color: '#3E3E3E'
                                        }}
                                    >
                                        {this.toHours(item.dhInclusao)}
                                    </Text>

                                    <Text
                                        style={{
                                            fontFamily:
                                                index === 0 ||
                                                index + 1 ===
                                                    this.props.listStatus.length
                                                    ? 'NunitoSans-Bold'
                                                    : 'NunitoSans-Regular',
                                            color: '#3E3E3E',
                                            fontSize: 14,
                                            marginLeft: 8
                                        }}
                                    >
                                        {item.dsStatusPedido}
                                    </Text>
                                </View>
                            </View>
                        </View>

                        {index + 1 !== this.props.listStatus.length && (
                            <View
                                style={{
                                    height: 50,
                                    borderLeft: '1px solid',
                                    marginLeft: 7,
                                    color: Colors.secondary
                                }}
                            />
                        )}
                    </View>
                ))}
            </View>
        );
    }
}

export default HistoricoStatus;
